export var FEATURE_EXAMPLE_ERROR_PAGES = 'enable_example_error_pages';
export var FEATURE_PROFILE_TIMEZONE = 'enable_poplar_profile_tz'; // Controls whether waitlist is enabled (if we don't have capacity for new members)

export var FEATURE_ENABLE_WAITLIST = 'enable_waitlist'; // Controls the roll out "I'll do it later" during the onboarding v2 task intake flow

export var FEATURE_DO_IT_LATER_INTAKE_ACTION = 'enable_poplar_do_it_later'; // Controls the roll out of Todo Discovery when creating a task in the flyout

export var FEATURE_ENABLE_TODO_DISCOVERY = 'enable_todo_discovery'; // Whether to start displaying recurring todo UI pieces or not.

export var FEATURE_ENABLE_RECURRING_TODOS = 'enable_poplar_recurring_todos'; // Controls the deprecation state of the Guide functionality.
// When set to true, Guide features are deprecated and disabled.

export var FEATURE_ENABLE_GUIDE_DEPRECATION = 'enable_poplar_guide_deprecation'; // Controls the rollout of Rejected and Cancelled proposal being shareable

export var FEATURE_EXTEND_PROPOSAL_SHARING = 'enable_poplar_extended_proposal_sharing'; // Controls whether we swap the order of ctas on purchase proposals

export var FEATURE_SWAP_PROPOSAL_CTAS = 'enable_poplar_purchase_proposal_cta_swap'; // Controls whether we enable the updated to-do feedback

export var FEATURE_UPDATE_MEMBER_TODO_FEEDBACK = 'enable_poplar_updated_member_feedback'; // Controls whether the updated onboarding 2.2 flow is setup

export var FEATURE_ONBOARDING_2_2 = 'enable_poplar_onboarding_2_2';
export var FEATURE_ENABLE_HOME_NEW_CATEGORIES = 'enable_poplar_home_new_categories';
export var FEATURE_PRIME_PRO_PREVIEW = 'enable_poplar_prime_pro_preview'; // Controls whether user can mark tasks as complete

export var FEATURE_ENABLE_MARK_AS_COMPLETED = 'enable_poplar_mark_as_completed'; // Prevents to-do handoff if a member has more than 10 active to-dos

export var FEATURE_PREVENT_TODO_HANDOFF_IF_MAX_REACHED = 'enable_poplar_todo_max_in_progress_reached'; // Controls whether we enable to use the task display name instead of the name

export var FEATURE_ENABLE_USE_TASK_DISPLAYNAME_INSTEAD_OF_NAME = 'enable_use_task_displayName_instead_of_name_poplar'; // Controls whether we disable the sign up flow for Yohana in the US

export var FEATURE_REMOVAL_SIGN_UP_YOHANA_US = 'enable_poplar_removal_sign_up_yohana_us'; // Controls whether we enable the CTA to skip the one-time a recurring task

export var FEATURE_ENABLE_REMOVAL_SKIP_ONE_TIME_CTA = 'enable_poplar_removal_skip_one_time_cta'; // Controls whether we enable the 3ds in poplar

export var FEATURE_3DS = 'enable_3ds';